export const ADD_NEW_HIGHLIGHT = `mutation ($name: String!, $icon: String!) {
    add_new_highlight(name: $name, icon: $icon){
      message
    }
  }
`;

export const ACTIVATE_HIGHLIGHT = `mutation ($id : String!) {
    activate_highlight(_id: $id){
      message
    }
  }
`;

export const LIST_ALL_HIGHLIGHTS = `query ($pageSize: Int, $pageNumber: Int) {
    list_all_highlights(page_size: $pageSize, page_number: $pageNumber){
      message
      data {
        _id
        name
        icon
        is_active
      }
      hasMore
    }
  }
`;

export const ADD_NEW_FACILITY = `mutation ($name: String!, $icon: String!) {
    add_new_facility(name: $name, icon: $icon){
      message
    }
  }
`;


export const LIST_ALL_FACILITIES = `query ($pageSize: Int, $pageNumber: Int) {
    list_all_facilities(page_size: $pageSize, page_number: $pageNumber){
      message
      data {
        _id
        name
        icon
        is_active
      }
      hasMore   
    }
  }
`;

export const LIST_ALL_RATES = `query ($pageSize: Int, $pageNumber: Int, $rateType: String, $roomtypeId: String, $startDate: Int, $endDate: Int ) {
  list_all_rates(page_size: $pageSize, page_number: $pageNumber, rate_type: $rateType, roomtype_id: $roomtypeId, start_date: $startDate, end_date: $endDate){
    message
    data {
      _id
      current_rate
      roomtype {
        name
        description
      }
    }
    hasMore
  }
}`;

export const ADD_NEW_RATE = `mutation ($roomId: String, $roomtypeId: String, $normalRate: Float, $offers: [add_new_rate_offers]) {
  add_new_rate(room_id: $roomId, roomtype_id: $roomtypeId, normal_rate: $normalRate, offers: $offers){
    message
  }
}`;

export const UPLOAD_FILE = `mutation ($file: String!, $fileType: String) {
  upload_file(file: $file, file_type: $fileType){
    message
    url
  }
}`;

export const CHANGE_HOTEL_PASSWORD = `mutation ($password: String!) {
  change_hotel_password(password: $password){
    message
  }
}`;

export const LIST_HOTEL_NOTIFICATIONS = `query {
  get_hotel_notifications {
    message
    data {
      booking_id
      checkin_date
      name
      email
      guest_mobile
      guest_phone
      paid_amount
      unpaid_amount
      booking_from
    }
  }
}`;

export const ADD_NEW_COUPON = `mutation ($coupon_name: String!, $discount_value: Float!, $check_in_date: String!, $check_out_date: String!, $hotel_id: String!) {   
  add_new_coupon(
    coupon_name: $coupon_name,
    discount_value: $discount_value,
    check_in_date: $check_in_date,
    check_out_date: $check_out_date,
    hotel_id: $hotel_id,
  ) {
    message
  }
}
`;

export const LIST_ALL_COUPONS = `query ($page_size: Int, $page_number: Int) {
  list_all_coupons(page_size: $page_size, page_number: $page_number) {
    message
    data {
      _id
      coupon_name
      coupon_code
      active
      discount_value
      redeem_count
      check_in_date
      check_out_date
    }
    hasMore
    totalCount
  }
}`;

export const UPDATE_COUPON = `
  mutation UpdateCoupon($coupon_id: String!, $check_out_date: String!) {
    update_coupon(coupon_id: $coupon_id, check_out_date: $check_out_date) {
      message
      updatedCoupon {
        _id
        check_out_date
      }
    }
  }
`;

export const LIST_ALL_HOTEL_INVOICES = `query (
  $page_size: Int, 
  $page_number: Int, 
  $start_date: Int,
  $end_date: Int,
  $pmt_status: [String]
) {
  list_all_hotel_invoices(
    page_size: $page_size, 
    page_number: $page_number, 
    start_date: $start_date,
    end_date: $end_date,
    pmt_status: $pmt_status
  ) {
    message
    data {
      _id
      inv_no
      inv_date
      checkin_date
      checkout_date
      booking_id
      customer_id {
        _id
        name
        email
        mobile
      }
      bill_to {
        type
        id
        name
        email
        mobile
        gst_number
        address
      }
      room_charges {
        groupId
        roomNumber
        particulars
        particular_type
        date
        roomType
        amount
        sgst
        cgst
        total
        sac_code
      }
      amount
      sgst
      cgst
      total
      paid_amount
      pmt_status
    }
    hasMore
    totalCount
  }
}`;

export const LIST_HOTEL_INVOICES_DETAILS = `query ($id: String!) {
  list_hotel_invoices_details(_id: $id) {
    message
    data {
      _id
      amount
      sgst
      cgst
      total
      hotel_id
      booking_id
      from
      inv_no
      inv_date
      checkin_date
      checkout_date
      customer_id
      pmt_status
      paid_amount
      room_charges {
        total
        sgst
        cgst
        groupId
        roomNumber
        roomType
        particulars
        date
        amount
        groupId
        sac_code
      }
      customer {
        title
        name
        email
        mobile
        address
        preference
        gst_no
      }
      bill_to {
        name
        mobile
        email
        address
        gst_number
        id
      }
      settlements {
        _id
        amount
        payment_mode
        transaction_ref
        settlement_date
        remarks
        settled_by
        createdAt
        updatedAt
      }
    }
  }
}
`;

export const UPDATE_HOTEL_INVOICES_DETAILS = `
  mutation UpdateHotelInvoice(
    $_id: String!,
    $amount: Float,
    $sgst: Float,
    $cgst: Float,
    $total: Float,
    $hotel_id: String,
    $booking_id: String,
    $from: String,
    $inv_no: String,
    $inv_date: Int,
    $checkin_date: Int,
    $checkout_date: Int,
    $customer_id: String,
    $pmt_status: String,
    $paid_amount: Float,
    $room_charges: [update_hotel_invoices_details_room_charges],
    $customer: update_hotel_invoices_details_customer
  ) {
    update_hotel_invoices_details(
      _id: $_id,
      amount: $amount,
      sgst: $sgst,
      cgst: $cgst,
      total: $total,
      hotel_id: $hotel_id,
      booking_id: $booking_id,
      from: $from,
      inv_no: $inv_no,
      inv_date: $inv_date,
      checkin_date: $checkin_date,
      checkout_date: $checkout_date,
      customer_id: $customer_id,
      pmt_status: $pmt_status,
      paid_amount: $paid_amount,
      room_charges: $room_charges,
      customer: $customer
    ) {
      message
    }
  }
`;

export const SEARCH_HOTEL_INVOICES = `
  query (
    $booking_id: String
    $room_number: String
    $checkin_date: Int
    $checkout_date: Int
  ) {
    search_hotel_invoices(
      booking_id: $booking_id
      room_number: $room_number
      checkin_date: $checkin_date
      checkout_date: $checkout_date
    ) {
      message
      data {
        _id
        invoice_id
        booking_id
        inv_no
        inv_date
        checkin_date
        checkout_date
        roomtype
        room_number
        customer_name
        room_charges {
          roomNumber
          particulars
          date
          roomType
          sgst
          cgst
          amount
          total
        }
        total
      }
      hasMore
      totalCount
    }
  }
`;

export const LIST_ALL_EXTRA_INVOICES = `query (
  $page_size: Int, 
  $page_number: Int, 
  $booking_id: String,
  $start_date: Int,
  $end_date: Int,
  $pmt_status: String
  $customer_name: String
) {
  list_all_extra_invoices(
    page_size: $page_size, 
    page_number: $page_number, 
    booking_id: $booking_id,
    start_date: $start_date,
    end_date: $end_date,
    pmt_status: $pmt_status
    customer_name: $customer_name
  ) {
    message
    data {
      _id
      inv_no
      booking_id
      inv_date
      customer_name
      extras {
        particulars
        quantity
        amount
        sgst
        cgst
        sac_code
        activity_id
      }
      amount
      sgst
      cgst
      total
      pmt_status
    }
    hasMore
    totalCount
  }
}`;

export const LIST_EXTRA_INVOICES_DETAILS = `query ($id: String!) {
  list_extra_invoices_details(_id: $id) {
    message
    data {
      _id
      amount
      sgst
      cgst
      total
      pmt_status
      is_deleted
      hotel_id
      booking_id
      customer_id
      inv_no
      inv_date
      from
      remarks
      extras {
        quantity
        sgst
        cgst
        activity_id
        particulars
        amount
        sac_code
      }
      customer_details {
        name
        email
        mobile
      }
    }
  }
}` 

export const UPDATE_EXTRA_INVOICES_DETAILS = `
  mutation (
    $_id: String!,
    $customer_details: update_extra_invoices_details_customer_details,
    $pmt_status: String,
    $booking_id: String,
    $inv_no: String,
    $remarks: String
  ) {
    update_extra_invoices_details(
      _id: $_id,
      customer_details: $customer_details,
      pmt_status: $pmt_status,
      booking_id: $booking_id,
      inv_no: $inv_no,
      remarks: $remarks
    ) {
      message
    }
  }
`;

export const ADD_EXTRA_INVOICE = `
  mutation AddExtraInvoice(
    $customer_details: add_extra_invoice_customer_details!
    $pmt_status: String!
    $inv_no: String
    $activities: [add_extra_invoice_activities]!
    $remarks: String
  ) {
    add_extra_invoice(
      customer_details: $customer_details
      pmt_status: $pmt_status
      inv_no: $inv_no
      activities: $activities
      remarks: $remarks
    ) {
      message
      _id
    }
  }
`;

export const ADD_NEW_RESTAURANT_INVOICE = `
  mutation AddNewRestaurantInvoice(
    $customer_name: String
    $customer_mobile: String
    $items: [add_new_restaurant_invoice_items!]
    $amount: Float
    $sgst: Float
    $cgst: Float
    $total: Float
    $pmt_status: String
    $remarks: String
  ) {
    add_new_restaurant_invoice(
      customer_name: $customer_name
      customer_mobile: $customer_mobile
      items: $items
      amount: $amount
      sgst: $sgst
      cgst: $cgst
      total: $total
      pmt_status: $pmt_status
      remarks: $remarks
    ) {
      message
      _id
    }
  }
`;

export const LIST_ALL_RESTAURANT_INVOICES = `
  query ListAllRestaurantInvoices(
    $page_size: Int!
    $page_number: Int!
    $customer_name: String
    $pmt_status: String
    $inv_no: String
    $inv_date_from: Int
    $inv_date_to: Int
  ) {
    list_all_restaurant_invoices(
      page_size: $page_size
      page_number: $page_number
      customer_name: $customer_name
      pmt_status: $pmt_status
      inv_no: $inv_no
      inv_date_from: $inv_date_from
      inv_date_to: $inv_date_to
    ) {
      message
      data {
        _id
        inv_no
        inv_date
        customer_name
        total
        pmt_status
      }
      hasMore
      totalCount
    }
  }
`;

export const LIST_RESTAURANT_INVOICE_DETAILS = `
  query ($id: String!) {
    list_restaurant_invoice_details(id: $id) {
      data {
        _id
        inv_no
        inv_date
        customer_name
        customer_mobile
        booking_id
        remarks
        items {
          item_name
          quantity
          rate
          amount
        }
        amount
        sgst
        cgst
        total
        pmt_status
      }
    }
  }
`;

export const LINK_RESTAURANT_INVOICE_TO_HOTEL_INVOICE = `
  mutation LinkRestaurantInvoiceToHotelInvoice(
    $restaurantInvoiceId: String!
    $bookingId: String!
  ) {
    link_restaurant_invoice_to_hotel_invoice(
      restaurantInvoiceId: $restaurantInvoiceId
      bookingId: $bookingId
    ) {
      success
      message
    }
  }
`;

export const UNLINK_RESTAURANT_INVOICE = `
  mutation($restaurantInvoiceId: String!) {
    unlink_restaurant_invoice(restaurantInvoiceId: $restaurantInvoiceId) {
      success
      message
    }
  }
`;

export const UPDATE_RESTAURANT_INVOICE_STATUS = `
  mutation (
    $id: String!
    $status: String!
  ) {
    update_restaurant_invoice_status(
      id: $id
      status: $status
    ) {
      success
      message
    }
  }
`;

export const ADD_INVOICE_SERIES_SETTINGS = `
  mutation AddInvoiceSeries(
    $hotel_billing: add_invoice_series_settings_hotel_billing
    $restaurant_billing: add_invoice_series_settings_restaurant_billing
    $activity_billing: add_invoice_series_settings_activity_billing
    $advance_receipt: add_invoice_series_settings_advance_receipt
  ) {
    add_invoice_series_settings(
      hotel_billing: $hotel_billing
      restaurant_billing: $restaurant_billing
      activity_billing: $activity_billing
      advance_receipt: $advance_receipt
    ) {
      message
    }
  }
`;
export const GET_INVOICE_SERIES_SETTINGS = `
  query ($hotel_id: String!) {
    get_invoice_series_settings(hotel_id: $hotel_id) {
      message
      data {
        hotel_billing {
          B2C {
            prefix
            start_number
            current_number
          }
          B2B {
            prefix
            start_number
            current_number
          }
          NON_GST {
            prefix
            start_number
            current_number
          }
          Complimentary {
            prefix
            start_number
            current_number
          }
          Proforma {
            prefix
            start_number
            current_number
          }
        }

        restaurant_billing {
          prefix
          start_number
          current_number
        }

        activity_billing {
          prefix
          start_number
          current_number
        }
        advance_receipt {
          prefix
          start_number
          current_number
        }
      }
    }
  }
`;

export const SEARCH_HOTEL_BOOKINGS = `
  query (
    $booking_id: String
    $room_number: String
    $checkin_date: Int
    $checkout_date: Int
  ) {
    search_hotel_bookings(
      booking_id: $booking_id
      room_number: $room_number
      checkin_date: $checkin_date
      checkout_date: $checkout_date
    ) {
      message
      data {
        _id
        booking_id
        guest_name
        guest_mobile
        meal_plan
        process_status
        status
        checkin_date
        checkout_date
        room_mappings {
          actual_room_no
          room_type
        }
      }
      hasMore
      totalCount
    }
  }
`;

export const PREVIEW_HOTEL_INVOICE = `query ($booking_id: String!) {
  preview_hotel_invoice(booking_id: $booking_id) {
    message
    data {
      hotel_invoice {
        _id
        amount
        sgst
        cgst
        total
        hotel_id
        booking_id
        from
        inv_no
        inv_date
        checkin_date
        checkout_date
        customer_id
        pmt_status
        paid_amount
        room_charges {
          total
          sgst
          cgst
          groupId
          roomNumber
          roomType
          particulars
          date
          amount
          sac_code
        }
        customer {
          title
          name
          email
          mobile
          address
          preference
          gst_no
        }
        bill_to {
          name
          mobile
          email
          address
          gst_number
          id
        }
      }
    }
  }
}
`;

export const GET_LINKED_RESTAURANT_INVOICES = `
  query($booking_id: String!) {
    get_linked_restaurant_invoices(booking_id: $booking_id) {
      message
      data {
        _id
        inv_no
        date
        grand_total
        payment_status
      }
    }
  }
`;

export const SETTLE_HOTEL_INVOICE = `
  mutation SettleHotelInvoice($invoice_id: String!, $settlement: settle_hotel_invoice_settlement!) {
    settle_hotel_invoice(invoice_id: $invoice_id, settlement: $settlement) {
      message
      success
    }
  }
`;

export const UPDATE_DAY_WISE_RATE_IN_ROOMS = `
  mutation UpdateDayWiseRateInRooms(
    $booking_id: String!,
    $rooms: [update_day_wise_rate_in_rooms_rooms]!,
    $overrideBookingTotal: Boolean,
    $newTotal: Float
  ) {
    update_day_wise_rate_in_rooms(
      booking_id: $booking_id,
      rooms: $rooms,
      overrideBookingTotal: $overrideBookingTotal,
      newTotal: $newTotal
    ) {
      message
      status
    }
  }
`;

